import { Business, Description, VpnKey } from '@mui/icons-material';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';

import CustomButton from '../../../../../../../../../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../../../../../../../../../lib/designSystem/CircularProgress';

interface CessionConfirmationDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedCertificate: {
    taxName: string;
    taxIdentifier: string;
    businessIdentifier: string;
  };
  passphrase: string;
  setPassphrase: (passphrase: string) => void;
  selected: unknown[];
  handleCession: () => void;
  loading: boolean;
  companyDetails: {
    name: string;
    taxIdentifier: string;
  };
}

const CessionConfirmationDialog = (props: CessionConfirmationDialogProps) => {
  const {
    open,
    setOpen,
    selectedCertificate,
    passphrase,
    setPassphrase,
    selected,
    handleCession,
    loading,
    companyDetails,
  } = props;

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          pb: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: 'rgba(25, 118, 210, 0.1)',
            borderRadius: '50%',
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Description sx={{ fontSize: '1.2rem', color: 'primary.main' }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Ceder Documentos
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 0 }}>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {/* Certificado Section */}
          <Grid item xs={12} md={6}>
            {/* <Paper
              elevation={1}
              sx={{
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: 2,
              }}
            > */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 2,
              }}
            >
              <Box
                sx={{
                  backgroundColor: 'rgba(76, 175, 80, 0.1)',
                  borderRadius: '50%',
                  p: 0.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <VpnKey sx={{ fontSize: '1rem', color: 'success.main' }} />
              </Box>
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, color: 'text.primary' }}
              >
                Certificado
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: '0.75rem' }}
                >
                  Nombre
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {selectedCertificate.taxName}
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: '0.75rem' }}
                >
                  RUT
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {selectedCertificate.taxIdentifier}
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: '0.75rem' }}
                >
                  RUT Empresa
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {selectedCertificate.businessIdentifier}
                </Typography>
              </Box>
            </Box>
            {/* </Paper> */}
          </Grid>

          {/* Cesionario Section */}
          <Grid item xs={12} md={6}>
            {/* <Paper
              elevation={1}
              sx={{
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: 2,
              }}
            > */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 2,
              }}
            >
              <Box
                sx={{
                  backgroundColor: 'rgba(156, 39, 176, 0.1)',
                  borderRadius: '50%',
                  p: 0.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Business sx={{ fontSize: '1rem', color: 'secondary.main' }} />
              </Box>
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, color: 'text.primary' }}
              >
                Cesionario
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: '0.75rem' }}
                >
                  Nombre
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {companyDetails.name}
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: '0.75rem' }}
                >
                  RUT
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {companyDetails.taxIdentifier}
                </Typography>
              </Box>
            </Box>
            {/* </Paper> */}
          </Grid>
        </Grid>

        {/* <Paper
          elevation={1}
          sx={{
            p: 2,
            border: '1px solid #e0e0e0',
            borderRadius: 2,
            mb: 2,
          }}
        > */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 2,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'rgba(255, 152, 0, 0.1)',
              borderRadius: '50%',
              p: 0.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Description sx={{ fontSize: '1rem', color: 'warning.main' }} />
          </Box>
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, color: 'text.primary' }}
          >
            Confirmación de Cesión
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Para confirmar la cesión de {selected.length}{' '}
          {selected.length > 1 ? 'documentos' : 'documento'}, debes ingresar la
          contraseña del certificado.
        </Typography>

        <TextField
          label="Contraseña del certificado"
          variant="outlined"
          type="password"
          fullWidth
          value={passphrase}
          onChange={(e) => setPassphrase(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        />
        {/* </Paper> */}
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 0, gap: 2 }}>
        <CustomButton
          onClick={() => setOpen(false)}
          color="secondary"
          variant="outlined"
        >
          Cancelar
        </CustomButton>
        <CustomButton
          onClick={() => handleCession()}
          color="primary"
          disabled={!passphrase.length}
        >
          Confirmar Cesión
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default CessionConfirmationDialog;
